import { createSelector } from 'reselect';
import ReceptaclesInPreconNotInPredesSummaryColumns
  from '../../containers/ReceptaclesInPreconNotInPredesSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPreconNotInPredesSummaryColumns);
